export class OclValidationError {
    constructor(message) {
        this.message = message;
    }
}
//# sourceMappingURL=OclValidationError.js.map